import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import NuDate from '../../../../Components/Utils/NuDate';
import { NuInput } from '../../../../Components/Utils/Input';
import { useFormik } from 'formik';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Video from '../../../../Components/Icons/Video';
import CloseIcon from '../../../../Components/Icons/Close';
import Pdf from '../../../../Components/Icons/Pdf';
import { useToast } from '../../../../Components/Others/ToastServices';
import { Modal } from 'antd';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import MultiSelect from '../../../../Components/Utils/MultiSelect';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import axiosInstance from '../../../../Services/axiosCommon';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];


function EditSchedulesTesting() {
  const navigate = useNavigate();
  const [image, setImage] = useState([]);
    
        const [selectedFile, setSelectedFile] = useState(null);
         const [filePathList, setFilePathList] = useState([]);
         const [fileRemoveList, setFileRemoveList] = useState([]);
                const [removefilePathList, setRemoveFilePathList] = useState([]);
                const [selectedImage, setSelectedImage] = useState(null);
                       const [fileExtention, setFileExtention] = useState("");
                              const [isModalOpen, setIsModalOpen] = useState(false);
                             const [searchClient, setSearchClient] = useState("");
                       
                              const { data: client, setDataCustomer } = UseCustomerDropDownNew(
                                "/clients/drop-down",
                                searchClient
                              );
                              const { data: user } = UseDropDown(`/user/new-drop-down`);
                              const { value: Status, getData: refStatus } = useFetchMataData(
                               `/dropdown/dropdown-details/`,
                               "Status_Schedules"
                             );
                             const { value: Type, getData: refType } = useFetchMataData(
                                  `/dropdown/dropdown-details/`,
                                  "Type_Schedules"
                                );
                                const { data: supplier } = UseDropDown(`/suppliers/drop-down/1`);
                                const { data: main } = UseDropDown(`/suppliers/drop-down/2`);
                             
                                const { data: installer } = UseDropDown(`/suppliers/drop-down/3`);
                                const { data: consultant } = UseDropDown(`/suppliers/drop-down/4`);
                                // const { data: Conductors } = UseDropDown(`/suppliers/drop-down/5`);
                             
                             
                const toast = useToast();
         
    const location = useLocation();
    // const data = location.state.data;

    // const cData = location.state?.data;
    const { scheduleEditId } = useParams();
    
     const [data,setData] = useState(null); 
     
    
     
   
   
    
  const from = location.state.from;

  const {  editFormData,isLoading } =useEditFormData(); 
     const [createNew, setCreateNew] = useState([]);
  function getView() {
    axiosInstance 
      .get(`/tc-schedules/${scheduleEditId}`)
      .then((res) => {
        res?.data?.data && setData(res?.data?.data);

        setCreateNew({
         clientId: res?.data?.data?.clientId  || "",
         projectName: res?.data?.data?.projectName  || "",
       type: res?.data?.data?.type  || "",
       location: res?.data?.data?.location  || "",
       mainContractor: res?.data?.data?.mainContractor  || "",
       status: res?.data?.data?.status   || "",
       date: res?.data?.data?.date  || "",
       consultant: res?.data?.data?.consultant  || "",
       supplier: res?.data?.data?.supplier  || "",
       installer: res?.data?.data?.installer  || "",
       conductors: res?.data?.data?.conductorsIds  || "",
       attachments: res?.data?.data?.attachments,
          refNumber: res?.data?.data?.refNumber,
       filesToRemove:[]
        });       
      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!cData) {
      getView();
    // }
  }, [])

  

const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        // phone: yup
        //   .string()
        //   .matches(/^\d+$/, "Phone number must contain only digits")
        //   .min(9, "Phone number must be at least 9 digits")
        //   .max(11, "Phone number must be at most 11 digits")
        //   .required("Phone number is required"),
        //   cPMobile: yup
        //   .string()
        //   .matches(/^\d+$/, "Phone number must contain only digits")
        //   .min(9, "Phone number must be at least 9 digits")
        //   .max(11, "Phone number must be at most 11 digits")
        //   .required("Contact Phone number is required"),
        // email: yup.string().required("Email is required!"),
        // companyName: yup.string().required("Company Name is required!"),
        // // website: yup.string().required("Website is required!"),
        // cpName: yup.string().required("Contact Person is required!"),
      }),
      onSubmit: async (value, { resetForm }) => {
        // setLoading(true);
        let formData = new FormData();
        const valueWithProducts = {
          ...value,
          // products: productsString,
          // services: servicesString,
          // emails: emailsString,
        filesToRemove: fileRemoveList,

         
        };
        formData.append("json_data", JSON.stringify(valueWithProducts));
        // formData.append("attachments", image.raw);
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("attachments", file);
          });
        } else {
          formData.append("attachments", []);
        }
                     await editFormData({url:`/tc-schedules/edit-tc-schedule/${scheduleEditId}`,formData:formData,navigateUrl:from ||`/Contract-management/schedules`,resetForm:resetForm   })

        // editFormData(
        //   `/tc-schedules/edit-tc-schedule/${scheduleEditId}`,
        //   formData,
        //   resetForm,
        //   from
        // );
        // setLoading(false);
      },
    });
 
 function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };
       
         useEffect(() => {
           if (
             data?.attachments !== null &&
             data?.attachments !== "None" &&
             data?.attachments !== "[]"
           ) {
             console.log(data?.attachments, "ghjkllgd");
             setFilePathList(data?.attachments);
       
             setRemoveFilePathList(data?.attachments || []);
           }
         }, [data]);
       
         function UpdateAttachmentList(item) {
           let filterList = filePathList.filter((itemList) => itemList.file !== item);
           let removeFile = filePathList.find((itemList) => itemList.file === item);
           console.log("llll", filterList);
           setFileRemoveList([...fileRemoveList, removeFile.file]);
           setFilePathList(filterList);
         }
       
         function handleImageClick(img) {
           let Ext = img?.file_name.split(".").reverse()[0];
           setSelectedImage(img);
           setFileExtention(Ext);
           setIsModalOpen(true);
         } 
 

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full "> 
         <Breadcrumb
                  items={[
                    // { name: "Testing&Commissioning" },
                    {   name: "Schedules" ,
                      link:"/Contract-management/schedules"
                    },
                    { name: "Edit" },
                  ]}
                />     
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
        <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
             
                    <SettingHeading title={`Commissioning Schedule : ${createNew?.refNumber}`}  />
                 
            </div>
             <FormikSelectTwo
                          label="Type"
                          Options={Type}
                          formik={formik}
                          placeholder="Choose"
                          name="type"
                          isRequired={true}
                          width="w-full md:w-1/3 md:-mt-2"
                          displayProperty={"Type"}
                          propertyName={"Type_Schedules"}
                             getFunc={refType}
                        />
            
                        <FormikSelectTwo
                          label="Client"
                          Options={client}
                          formik={formik}
                          placeholder="Choose"
                          name="clientId"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            
                         <NuInput
                         type="text"
                          label="Project Name"
                  //         Options={[
                  //           { value: "project1", label: "Project X" },
                  // { value: "project2", label: "Project Y" },
                  //         ]}
                          formik={formik}
                          placeholder="Choose"
                          name="projectName"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            
            <FormikSelectTwo
                          label="Main Contractor"
                          Options={main}
                          formik={formik}
                          placeholder="Choose"
                          name="mainContractor"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            
            <FormikSelectTwo
                          label="Consultant"
                          Options={consultant}
                          formik={formik}
                          placeholder="Choose"
                          name="consultant"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            
            <MultiSelect
                          label="Conductors"
                          Options={user}
                          formik={formik}
                          placeholder="Choose"
                          name="conductors"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            
            <FormikSelectTwo
                          label="Supplier"
                          Options={supplier}
                          formik={formik}
                          placeholder="Choose"
                          name="supplier"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            <NuInput
                          type="date"
                          label="Date"
                          placeholder="Date"
                          formik={formik}
                          name="date"
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            
            
            <FormikSelectTwo
                          label="Installer"
                          Options={installer}
                          formik={formik}
                          placeholder="Choose"
                          name="installer"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        />
                        
                        <NuInput
                          type="text"
                          label="Location"
                          placeholder="Location"
                          formik={formik}
                          name="location"
                          width="w-full md:w-1/3 md:-mt-2"
                        />
                        
                         {/* <FormikSelectTwo
                          label="Conducted by"
                          Options={[
                            { value: "John", label: "John" },
                  { value: "Jane", label: "Jane" },
                          ]}
                          formik={formik}
                          placeholder="Choose"
                          name="Conductedby"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                        /> */}
                       
                        <NuDate
                          label="Date"
                          placeholder="Date"
                          formik={formik}
                          name="date"
                         
                          width="w-full md:w-1/3 md:-mt-2"
                        />
            
            <DropDownAddMetaData
                          label="Status"
                          Options={Status}
                          formik={formik}
                          placeholder="Choose"
                          name="status"
                          isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                          displayProperty={"Status"}
                          propertyName={"Status_Schedules"}
                             getFunc={refStatus}
            
                        />

<div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Attachement
                  </p>
                  <Attachement 
                      handleChange={handleImageChange}
                      preview={image || ""}
                      width="w-full md:w-1/2"
                      label="Attach"
                      multiple={true}
                removeImages={removeImages}

                    />
                </div>
                <div className="md:flex justify-between mt-5 px-3 w-full">
                  <div className="w-full flex gap-2 items-center flex-wrap">
                    {filePathList &&
                      filePathList?.map((imgs, idx) => {
                        console.log("img", imgs);
                        let Ext = imgs?.file_name.split(".").reverse()[0];
                        return (
                          <div
                            className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                            key={idx}
                            style={{
                              border: "1px solid gray",
                              borderColor:
                                "rgb(148 163 184 / var(--tw-bg-opacity))",
                            }}
                          >
                            <div
                              className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                              onClick={() => UpdateAttachmentList(imgs?.file)}
                            >
                              <CloseIcon color="white" height="8" width="8" />
                            </div>
                            <div
                              className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                              onClick={() => handleImageClick(imgs)}
                            >
                              <div className=" w-8 h-8">
                                {videotype.includes(Ext) ? <Video /> : null}
  
                                {Ext === ("docx" || "doc" || "txt") ? (
                                  <Doc />
                                ) : Ext === ("xlsx" || "xls") ? (
                                  <Xls />
                                ) : Ext === "txt" ? (
                                  <Txt />
                                ) : Ext === "pdf" ? (
                                  <Pdf />
                                ) : Ext === "PDF" ? (
                                  <Pdf />
                                ) : Ext === "pptx" ? (
                                  <>No file</>
                                ) : (
                                  <img src={imgs?.file} alt="#" width="120%" />
                                )}
                              </div>
                              <p className=" w-[50px] text-[11px] truncate">
                                {imgs?.file_name}
                              </p>
                            </div>
                          </div>
                        );
                      })}
  
                  
                  </div>
                </div>
           
           
            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <img src={selectedImage?.file} alt={selectedImage?.file} />
              </Modal>
    </div>
  );
}

export default EditSchedulesTesting
